import { RootModelAction, TypedAction } from '../actions';
import { UserApi } from '../api-typings/users/users';
import {
  mergeEntities,
  mergeWebsocketEntities,
  transformObjects,
} from '../store.helpers';
import { StoreFeatureState } from '../store.model';
import { transformUser } from '../user/user.transformers';

export function usersReducer(
  state: StoreFeatureState<'users'> = {},
  action: TypedAction | RootModelAction<'contacts'>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (
        action.payload.type === 'threads' ||
        action.payload.type === 'contests' ||
        action.payload.type === 'threadProjects'
      ) {
        const { result, ref } = action.payload;
        if (result.users) {
          return mergeWebsocketEntities<'users'>(
            state,
            transformObjects(Object.values(result.users), transformUser),
            {
              path: ['users', ref.path[1], undefined],
            },
          );
        }
        return state;
      } else if (action.payload.type === 'users') {
        const { result, ref } = action.payload;
        if (result.users) {
          return mergeEntities<'users'>(
            state,
            transformObjects(Object.values(result.users), transformUser),
            ref,
          );
        }
        return state;
      } else if (action.payload.type === 'contacts') {
        const users = action.payload.result.contacts
          ? action.payload.result.contacts.map((c: { user: UserApi }) => c.user)
          : [];
        const { ref } = action.payload;
        return mergeWebsocketEntities<'users'>(
          state,
          transformObjects(Object.values(users), transformUser),
          { path: ['users', ref.path[1], undefined] },
        );
      }
      return state;
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/user/user.reducer.ts